import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/modules/material.module';

import { EditActionComponent } from './edit-action/edit-action.component';
import { DeleteActionComponent } from './delete-action/delete-action.component';
import { ReceivalsActionComponent } from './receivals-action/receivals-action.component';
import { ProductLinkActionComponent } from './product-link-action/product-link-action.component';
import { DownloadWmActionComponent } from './download-wm-action/download-wm-action.component';
import { GroupIngestActionComponent } from './group-ingest-action/group-ingest-action.component';
import { MastersuiteApplyMenuItemComponent } from './mastersuite-apply/mastersuite-apply-menu-item.component';
import { MastersuiteApplyComponent } from './mastersuite-apply/mastersuite-apply.component';

const COMPONENTS = [
  EditActionComponent,
  DeleteActionComponent,
  ReceivalsActionComponent,
  ProductLinkActionComponent,
  DownloadWmActionComponent,
  GroupIngestActionComponent,
  MastersuiteApplyMenuItemComponent,
  MastersuiteApplyComponent,
];

@NgModule({
  declarations: COMPONENTS,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, MaterialModule],
  exports: COMPONENTS,
})
export class ProductActionsModule {}
